// extracted by mini-css-extract-plugin
export default {"spinner":"src-components-atoms-spinner-spinner-module__spinner--cX0OY","spin":"src-components-atoms-spinner-spinner-module__spin--TlNvn"};